import { Injectable } from '@angular/core';
import { RequestService } from 'src/app/core/service/request.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class ConsentFormService {

  constructor(
    private requestService: RequestService
  ) { }

  SearchConsentFormData(CompanyID:string,UserID:string){
      var param = {
        "CompanyID": CompanyID,
        "UserID": UserID
      };
      return this.requestService.Post<any>(environment.baseUrl + '/Liff/SearchConsentFormData',param);
  }
  SaveSign(model:any){
    return this.requestService.Post<any>(environment.baseUrl + '/Liff/SaveSign',model);
  }
}
